export const environment = {
  production: false,
  API_URL: "https://hc-api.dev.preczn.com",
  TEMP_API_URL: "https://api.dev.preczn.com/v1/",
  HOST_URL: "https://checkout.dev.preczn.com",
  domain: 'https://core.dev.preczn.com'
};
